import { BaseService } from "./BaseService";
import Collections from "../commons/Collections";
import FunctionNames from "../commons/FunctionNames";
import Helpers from "../commons/Helpers";
import axios from "axios";
export class UserService extends BaseService {
  async getAppUsers() {
    const response = {
      ok: false,
      message: "",
    };
    try {
      return await this.http(`app/users`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      response.message = error.message;
    }
    return response;
  }

  async getAdminUsers() {
    try {
      return await this.http(`app/users?only_web=1`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      response.message = error.message;
    }
  }

  async getPalla(receiverId) {
    try {
      return await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URL}app/palla/${receiverId}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log("ERR ", error);
      response.message = error.message;
    }
  }

  deleteAdminUser(userEmail, uid) {
    const _deleteUser = this.getCallableFunction(FunctionNames.deleteAdminUser);
    return _deleteUser({
      email: userEmail,
      uid: uid,
    });
  }

  async changeAdminUserPassword(uid, password) {
    return this.http(`app/changeUserPassword`, "post", { uid, password });
  }

  createAdminUser(companies, name, password, role) {
    const _fun = this.getCallableFunction(FunctionNames.createAdminUser);
    return _fun({
      companies,
      name,
      password,
      role,
    });
  }

  async saveLoginLog(userId) {
    try {
      const result = await this.getCollectionRef(
        `${Collections.users}/${userId}/${Collections.accessLog}`
      ).add({
        date: this.getServerTimestamp(),
      });
    } catch (error) {
      console.log("ERR saveLoginLog ", error);
    }
  }
}
